import { selectSelectedSprayEventIdsForSubmission } from 'services/selectedSprayEventIdsForSubmission/selectors';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { makeSelectQueryStringNumberValue } from 'workspaces/react-router-selectors';
import { SELECTED_SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME } from './constants';

const selectSelectedSprayEventIdsForSubmissionPaginated = createDeepEqualSelector(
    selectSelectedSprayEventIdsForSubmission,
    makeSelectQueryStringNumberValue(
        SELECTED_SPRAY_EVENT_IDS_TABLE_PAGINATION_NAME
    ),
    makeSelectQueryStringNumberValue('count'),
    (
        selectedSprayEventIdsForSubmission,
        pageState: any = 1,
        countState: any = 10
    ) => {
        const begin = (pageState - 1) * countState;
        const end = pageState * countState;
        return selectedSprayEventIdsForSubmission.slice(begin, end);
    }
);

const makeSelectSelectedSprayEventIdsForSubmissionPaginated = (): typeof selectSelectedSprayEventIdsForSubmissionPaginated =>
    selectSelectedSprayEventIdsForSubmissionPaginated;

const selectSprayEventIdsForSubmissionLength = createDeepEqualSelector(
    selectSelectedSprayEventIdsForSubmission,
    (selectedSprayEventIdsForSubmission) =>
        selectedSprayEventIdsForSubmission.length
);

export {
    selectSprayEventIdsForSubmissionLength,
    makeSelectSelectedSprayEventIdsForSubmissionPaginated
};
